export default "<button mat-stroked-button xpoSmallButton style=\"margin-top: 1px;\" (click)=\"onClick(params.value)\">\n  {{ params.value }}\n</button>\n"